import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { CheckCircle, ArrowRight } from 'lucide-react';

const ThankYouPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black text-white">
      <Navbar />
      
      <section className="pt-32 pb-20 px-6 relative">
        <div className="max-w-4xl mx-auto text-center">
          {/* Success Icon */}
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-gradient-to-br from-cyan-500/20 to-blue-500/20 border-2 border-cyan-500/50 mb-8">
            <CheckCircle className="w-12 h-12 text-cyan-400" />
          </div>

          {/* Heading */}
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            <span className="text-white">Thank You!</span>
            <br />
            <span className="bg-gradient-to-r from-cyan-400 via-blue-400 to-cyan-500 bg-clip-text text-transparent">
              We&apos;ll Be In Touch Soon
            </span>
          </h1>

          {/* Message */}
          <p className="text-xl text-gray-300 mb-12 max-w-2xl mx-auto leading-relaxed">
            We&apos;ve received your message and our team will get back to you shortly. 
            In the meantime, feel free to explore more about Traain™ and how we&apos;re 
            transforming talent intelligence.
          </p>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={() => navigate('/')}
              className="px-8 py-4 bg-cyan-500 text-black font-semibold rounded-lg hover:bg-cyan-400 transition-all duration-200 hover:scale-105 text-lg"
            >
              Back to Home
              <ArrowRight className="w-5 h-5 ml-2 inline" />
            </button>
            <button
              onClick={() => navigate('/features')}
              className="px-8 py-4 border-2 border-cyan-500 text-cyan-400 font-semibold rounded-lg hover:bg-cyan-500/10 transition-all duration-200 text-lg"
            >
              Explore Features
            </button>
          </div>

          {/* Additional Info */}
          <div className="mt-16 p-8 rounded-2xl bg-gradient-to-br from-gray-900/80 to-blue-900/20 border border-cyan-500/30">
            <h3 className="text-2xl font-bold text-white mb-4">
              What Happens Next?
            </h3>
            <div className="grid md:grid-cols-3 gap-6 text-left">
              <div>
                <div className="text-cyan-400 font-bold mb-2">1. We Review</div>
                <p className="text-gray-400 text-sm">
                  Our team carefully reviews your inquiry and gathers any relevant information.
                </p>
              </div>
              <div>
                <div className="text-cyan-400 font-bold mb-2">2. We Reach Out</div>
                <p className="text-gray-400 text-sm">
                  A member of our team will contact you within 1-2 business days.
                </p>
              </div>
              <div>
                <div className="text-cyan-400 font-bold mb-2">3. We Connect</div>
                <p className="text-gray-400 text-sm">
                  We&apos;ll discuss your needs and show you how Traain™ can help.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ThankYouPage;
